module.exports = __webpack_public_path__ + "img/pangao_user_add_bg.73fba8f6.png";